import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Uygulama hazır olur olmaz açılış (splash) katmanını kapat.
const yzSplash = document.getElementById("yz-splash");
if (yzSplash) {
  yzSplash.style.pointerEvents = "none";
  yzSplash.style.transition = "opacity .3s ease";
  requestAnimationFrame(() => { yzSplash.style.opacity = "0"; });
  setTimeout(() => yzSplash.remove(), 400);
}
